'use strict';

import Callout from './components/callout';

const formHelpers = require('./util/formErrors');

class newsletter {
  constructor() {
    this.newsletterForm = $('.newsletterform');
    this.submitNewsletterForm = this.newsletterForm.find('.button');

    this.unsubscribeForm = $('.unsubscribeform');
    this.submitUnsubscribeForm = this.unsubscribeForm.find('.button');
  }

  run() {
    // this.checkProfiling();
    this.submitNewsletterPage();
    this.submitUnsubscribePage();

    const googleRecaptchaClientSide = document.querySelector('input[name="googleRecaptchaClientSide"]');
    if (googleRecaptchaClientSide) {
      grecaptcha.ready(function () {
        grecaptcha.execute(googleRecaptchaClientSide.value, { action: 'newsletter_form' }).then(function (token) {
          $('.registration-form').prepend(`<input type="hidden" name="googleRecaptchaToken" value="${token}">`);
          $('.registration-form').prepend('<input type="hidden" name="googleRecaptchaAction" value="newsletter_form">');
        });
        setInterval(function () {
          grecaptcha.execute(googleRecaptchaClientSide.value, { action: 'newsletter_form' }).then(function (token) {
            $('input[name=googleRecaptchaToken]').val(token);
          });
        }, 90000); // tokens gets marked as expired after 2 mins https://github.com/google/recaptcha/issues/302
      });
    }
  }

  submitNewsletterPage() {
    this.submitNewsletterForm.click((e) => {
      e.preventDefault();

      var $form = this.newsletterForm;
      var action = $form.attr('action');
      var validation = $('.newsletterform').parsley().validate();

      const button = $form.find('.button');

      if (validation) {
        $(button).attr('disabled', true);
        $.ajax({
          url: action,
          type: 'post',
          data: $form.serialize(),
          success: (response) => {
            formHelpers.clearPreviousErrors($form);
            if (response.success) {
              $form.find('input[name$=_email]').val('');
              if (response.alreadyRegistered) {
                var dataLayerObject = {
                  event: 'asyncAction',
                  gaHitType: 'event',
                  event_category: 'newsletter_subscription',
                  event_action: 'ko',
                  event_label: response.errorMessage
                };
              } else {
                var dataLayerObject = {
                  event: 'asyncAction',
                  gaHitType: 'event',
                  event_category: 'newsletter_subscription',
                  event_action: 'ok'
                };
              }


              dataLayer.push(dataLayerObject);
              window.location.href = response.redirectUrl;
            } else {
              $(button).attr('disabled', false);
              var dataLayerObject = {
                event: 'asyncAction',
                gaHitType: 'event',
                event_category: 'newsletter_subscription',
                event_action: 'ko',
                event_label: response.errorMessage
              };

              dataLayer.push(dataLayerObject);
              formHelpers.resetErrorList($form, response.error);
              formHelpers.loadFormErrors($form, response.error);
              Callout.error(null, $form.data('error'), $('#newsletter-error'));
            }
          },
          error: () => {}
        });
      }
    });
  }

  submitUnsubscribePage() {
    this.submitUnsubscribeForm.click((e) => {
      e.preventDefault();

      var $form = this.unsubscribeForm;
      var action = $form.attr('action');

      var button = $form.find('.button');
      $(button).attr('disabled', true);

      $.ajax({
        url: action,
        type: 'post',
        data: $form.serialize(),
        success: (response) => {
          formHelpers.clearPreviousErrors($form);
          if (response.success) {
            $form.find('input[name$=_email]').val('');
            window.location.href = response.redirectUrl;
          } else {
            $(button).attr('disabled', false);
            formHelpers.resetErrorList($form, response.error);
            formHelpers.loadFormErrors($form, response.error);
          }
        },
        error: () => {}
      });
    });
  }

  checkProfiling() {
    const profiling = $('#profiling');

    $('#email-signup').on('change', (e) => {
      const self = $(e.currentTarget);

      if (self.is(':checked')) {
        profiling.removeAttr('disabled');
      } else {
        profiling.attr('disabled', 'disabled');

        if (profiling.is(':checked')) {
          profiling.prop('checked', false);
        }
      }
    });
  }
}

const Newsletter = new newsletter();
Newsletter.run();



// WEBPACK FOOTER //
// ./assets/scripts/newsletter.js